module.exports = __webpack_public_path__ + "static/img/Lucas 2.91d777d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoPeople/Lucas 2.png
// module id = y2/d
// module chunks = 1